export default __webpack_public_path__ + "media/images/features/local_delivery/episode5/LP_04-1d54e42d1ed95328d68eaaa18f07afdd.jpeg";